import PedidoSubItemService from "@/services/PedidoSubItemService";

export const pedidoSubItem = {
  namespaced: true,
  state: {
    pedidoSubItem: {},
  },
  actions: {
    getPedidoSubItem({ commit }, payload) {
      return PedidoSubItemService.GetPedidoSubItem(payload).then(
        (pedidoSubItem) => {
          return Promise.resolve(pedidoSubItem);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postPedidoSubItem({ commit }, payload) {
      return PedidoSubItemService.PostPedidoSubItem(payload).then(
        (pedidoSubItem) => {
          return Promise.resolve(pedidoSubItem);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putPedidoSubItem({ commit }, payload) {
      return PedidoSubItemService.PutPedidoSubItem(payload).then(
        (pedidoSubItem) => {
          return Promise.resolve(pedidoSubItem);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deletePedidoSubItem({ commit }, payload) {
      return PedidoSubItemService.DeletePedidoSubItem(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getPedidoSubItemOData({ commit }, payload) {
      return PedidoSubItemService.GetPedidoSubItemOData(payload).then(
        (pedidoSubItem) => {
          return Promise.resolve(pedidoSubItem);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default pedidoSubItem;
